import * as __glob_0 from './../accent-tag.js';
import * as __glob_1 from './../accordion-feature.js';
import * as __glob_2 from './../accordion.js';
import * as __glob_3 from './../blog-list.js';
import * as __glob_4 from './../blog-tags.js';
import * as __glob_5 from './../circular-feature-accordion.js';
import * as __glob_6 from './../circular-feature.js';
import * as __glob_7 from './../customer-stories-tabs.js';
import * as __glob_8 from './../dots.js';
import * as __glob_9 from './../draggable-card-list.js';
import * as __glob_10 from './../dropdown.js';
import * as __glob_11 from './../filter.js';
import * as __glob_12 from './../hero-video.js';
import * as __glob_13 from './../home-hero.js';
import * as __glob_14 from './../image-marquee.js';
import * as __glob_15 from './../lined-bg.js';
import * as __glob_16 from './../logo-tabs.js';
import * as __glob_17 from './../s-lines.js';
import * as __glob_18 from './../scrolling-text-block.js';
import * as __glob_19 from './../sticky-pill.js';
import * as __glob_20 from './../tabs.js';
import * as __glob_21 from './../text-content.js';
import * as __glob_22 from './../tooltip.js';
const modules = { "./../accent-tag.js": __glob_0, "./../accordion-feature.js": __glob_1, "./../accordion.js": __glob_2, "./../blog-list.js": __glob_3, "./../blog-tags.js": __glob_4, "./../circular-feature-accordion.js": __glob_5, "./../circular-feature.js": __glob_6, "./../customer-stories-tabs.js": __glob_7, "./../dots.js": __glob_8, "./../draggable-card-list.js": __glob_9, "./../dropdown.js": __glob_10, "./../filter.js": __glob_11, "./../hero-video.js": __glob_12, "./../home-hero.js": __glob_13, "./../image-marquee.js": __glob_14, "./../lined-bg.js": __glob_15, "./../logo-tabs.js": __glob_16, "./../s-lines.js": __glob_17, "./../scrolling-text-block.js": __glob_18, "./../sticky-pill.js": __glob_19, "./../tabs.js": __glob_20, "./../text-content.js": __glob_21, "./../tooltip.js": __glob_22 };
// console.log("modules -> []", modules);

// Extend HTMLElement interface to include our custom property
declare global {
  interface HTMLElement {
    _moduleInitialized?: boolean;
  }
}

export function createCycles(dataAttribute = "module") {
  return Array.from(document.querySelectorAll(`[data-${dataAttribute}]`))
    .map((element) => {
      const htmlElement = element as HTMLElement;
      const attributeValue = htmlElement.dataset[dataAttribute];

      // Check if THIS SPECIFIC ELEMENT is already initialized
      if (htmlElement._moduleInitialized) {
        return null; // Skip this specific element
      }

      const modulePath = modules[`./../${attributeValue}.ts`]
        ? `./../${attributeValue}.ts`
        : `./../${attributeValue}.js`;

      if (modules[modulePath]) {
        // Expecting a default export function
        const moduleFn = (
          modules[modulePath] as {
            default: (el: HTMLElement, dataset: DOMStringMap) => any;
          }
        ).default;
        if (typeof moduleFn === "function") {
          try {
            // Mark THIS SPECIFIC ELEMENT as initialized
            htmlElement._moduleInitialized = true;

            return moduleFn(htmlElement, htmlElement.dataset);
          } catch (error) {
            // Remove the flag if initialization fails
            delete htmlElement._moduleInitialized;
            console.warn(
              `Failed to call default function for ${dataAttribute} "${attributeValue}":`,
              error
            );
            return null;
          }
        } else {
          console.warn(
            `Default export is not a function for ${dataAttribute} "${attributeValue}"`
          );
          return null;
        }
      } else {
        console.warn(`${dataAttribute} not found: "${attributeValue}"`);
        return null;
      }
    })
    .filter((item) => item !== null);
}

// Optional: Helper function to manually clear initialization for testing
export function clearModuleInitialization(element: HTMLElement) {
  delete element._moduleInitialized;
}
